import { styled } from '@components-shared/src/stitches';

export const AVATAR_SIZE = 28;

export const Container = styled('div', {
  marginTop: 32,
  '@tablet': {
    marginTop: 64,
  },
});

export const SplitsContentTitle = styled('h5', {
  base: 'L',
  fontWeight: 600,
});

export const SplitsContentCredits = styled('div', {
  display: 'grid',
  columnGap: 26,
  '@tablet': {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
});

export const SplitUser = styled('div', {
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  justifyContent: 'space-between',
  borderBottom: '1px solid $neutral200',
  paddingY: 12,
  base: 'L',
  fontStyle: 'regular',
});

export const Percent = styled('div', {
  fontStyle: 'semibold',
  fontSize: 13,
  lineHeight: '20px',
  textAlign: 'center',
  color: '$neutral500',
  background: '$neutral100',
  borderRadius: 6,
  paddingX: 2,
});

export const AvatarContainer = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: 12,
});

export const NameContainer = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: 6,
});

export const Name = styled('h3', {
  maxWidth: 118,
  width: 'fit-content',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});
